import React, { useEffect, useState } from "react";
import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { motion, AnimatePresence } from "framer-motion";

const STORAGE_KEY = "transcap.cookie.consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const existing = localStorage.getItem(STORAGE_KEY);
      if (!existing) {
        // Delay slightly so it doesn't fight the hero animations.
        const t = setTimeout(() => setVisible(true), 1200);
        return () => clearTimeout(t);
      }
    } catch (e) {
      // localStorage may be blocked (e.g., Safari private mode). Fail silent.
    }
  }, []);

  const record = (value) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ value, at: new Date().toISOString() })
      );
    } catch (e) {
      /* noop */
    }
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 60, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          style={{
            position: "fixed",
            zIndex: 999,
            left: "50%",
            bottom: "84px",
            transform: "translateX(-50%)",
            width: "min(calc(100% - 24px), 640px)",
          }}
        >
          <Flex
            p={{ base: "16px", md: "20px" }}
            borderRadius="18px"
            bg="rgba(10,22,40,0.94)"
            backdropFilter="blur(18px) saturate(1.6)"
            border="1px solid rgba(255,255,255,0.12)"
            boxShadow="0 30px 60px -20px rgba(15,23,42,0.55)"
            color="white"
            direction={{ base: "column", md: "row" }}
            align={{ base: "flex-start", md: "center" }}
            gap="14px"
          >
            <Box flex="1">
              <Text fontSize="14.5px" fontWeight={700} color="white">
                We use cookies to improve your experience.
              </Text>
              <Text mt="4px" fontSize="13px" color="slate.400" lineHeight="1.5">
                By using this site you agree to our use of cookies for
                analytics and site functionality.{" "}
                <Text
                  as="a"
                  href="/privacy"
                  color="accent.400"
                  fontWeight={600}
                  _hover={{ textDecoration: "underline" }}
                >
                  Learn more
                </Text>
                .
              </Text>
            </Box>
            <Flex gap="8px" flexShrink={0}>
              <Button
                variant="glass"
                onClick={() => record("declined")}
                h="40px"
                px="16px"
                fontSize="13px"
              >
                Decline
              </Button>
              <Button
                onClick={() => record("accepted")}
                h="40px"
                px="18px"
                fontSize="13px"
              >
                Accept all
              </Button>
            </Flex>
          </Flex>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
